import { useEffect } from 'react';

import Start from "../../components/Start";
import Partners from "../../components/Partners";
import Rise from "../../components/Rise";
import Value from "../../components/Value";
import Footer from "../../components/Footer";
import HowItWorks from "../../components/HowItWorks";

const Main = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [])

    return (
        <>
            <Start />
            <Partners />
            <Rise />
            <HowItWorks />
            <Value />
            <Footer />

        </>
    );
};

export default Main;
